<template>
    <span @click="openEmailPanel">{{ getLabel }} </span>
</template>

<script>
import EmailMixins from '../../mixins/EmailMixins';
import Store from 'stores/overview/document/store';
import { createNamespacedHelpers } from 'vuex';
const { mapState } = createNamespacedHelpers('documentOverview');

export default {
    name: 'DocumentSendEmail',
    mixins: [EmailMixins],
    props: {
        linkedtype: {
            type: String,
            required: true,
        },
        linkedid: {
            type: [String, Number],
            required: true,
        },
        doclabel: {
            type: String,
            default: '',
        },
        fileid: {
            type: String,
            default: '',
        },
        label: {
            type: String,
            default: '',
        },
        clickAction: {
            type: String,
            default: '',
        },
    },
    computed: {
        ...mapState(['fileId', 'docFile']),
        getLabel() {
            return this.label.trim() !== '' ? this.label : this.$l10n.__('Envoyer par email');
        },
    },
    async created() {
        this.getSettings();

        if (!this.$store.state.documentOverview) {
            this.$store.registerModule('documentOverview', Store);

            this.$store.commit('documentOverview/init', {
                doclabel: this.doclabel,
                fileId: this.fileid,
            });
        }

        if (!this.fileId) {
            this.$store.dispatch('documentOverview/setFileId', this.fileid);
        }

        if (!this.docFile) {
            this.$store.dispatch('documentOverview/getDocFile');
        }
    },
    methods: {
        openEmailPanel() {
            if (!!this.clickAction) {
                return;
            }

            if (!this.docFile) {
                this.$store.dispatch('documentOverview/getDocFile');
            }

            let params = {
                relatedtype: this.linkedtype,
                relatedid: this.linkedid,
                doclabel: this.doclabel,
            };

            if (!['purInvoice', 'purCreditNote', 'purDelivery'].includes(this.linkedtype)) {
                params = {
                    ...params,
                    template: {
                        type: 'document',
                        contact: {
                            id: parseInt(this.linkedid),
                            type: this.linkedtype,
                        },
                        related: [
                            {
                                id: parseInt(this.linkedid),
                                type: this.linkedtype,
                            },
                        ],
                    },
                };
            }

            this.checkEmailProvider(
                {
                    ...params,
                },
                { checkPrefill: true },
            );
        },
    },
};
</script>

<style lang="scss" scoped>
span {
    color: var(--colors-common-text-primary-default);
}
</style>
